<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <uber_general_tab :location="location"></uber_general_tab>
        </template>
    </base_location_modal>
</template>

<script>

import base_location_modal from "../../base/location_modal/base_location_modal";
import uber_general_tab from "./tabs/uber_general_tab";


export default {
    name: "uber_location_modal",
    components : {
        base_location_modal,
        uber_general_tab,
    },

    data () {
        return {
            tabs_add : [

            ]
        }
    },
}
</script>

<style scoped>

</style>
